/** Las fuentes que ESTA respuesta usó, arriba y visibles.
 *
 * De las referencias: es lo que hace que Perplexity gane en confianza percibida — la fuente es
 * prominente, no un pie de página. Aquí importa más que en un buscador: el lector necesita saber
 * que la cifra viene del laboratorio de Kunheim y no de un modelo, antes de leer la cifra.
 */
import type { Fuente, Idioma, Nivel } from "../lib/tipos";
import { bi, t } from "../lib/i18n";

export function TiraFuentes({ fuentes, niveles, corte, idioma }: {
  fuentes: Fuente[]; niveles: Nivel[]; corte: string; idioma: Idioma;
}) {
  const txt = t(idioma);
  if (!fuentes.length) return null;
  const unicas = [...new Map(fuentes.map((f) => [f.fuente_id, f])).values()];
  return (
    <div className="tira-fuentes">
      <ul>
        {unicas.map((f) => (
          <li key={f.fuente_id} title={`${f.sistema_origen} · ${txt.owner}: ${f.owner}`}>
            {bi(f.nombre, idioma)}
            {!f.declarada_en_slide && <span className="punto-aviso" aria-label={txt.asumida}>*</span>}
          </li>
        ))}
      </ul>
      <span className="tira-meta">
        {niveles.map((n) => (
          <span key={n} className={`chip nivel-${n}`}>{txt.niveles[n]}</span>
        ))}
        {corte && <span className="tira-corte">{corte}</span>}
      </span>
    </div>
  );
}
